import { Color } from "@starrez/starryui";
import styled, { keyframes } from "styled-components";
import { IAttachmentListWrapperStyleProps } from ".";

const fadeIn = keyframes`
  0% {
    transform: scale(0);
    transform-origin: 0% 0%;
    opacity: 0;
    visibility: hidden;
  }
  100% {
    transform: scale(1);
    transform-origin: 0% 0%;
    opacity: 1;
    visibility: visible;
  }
`;

const fadeOut = keyframes`
  0% {
    transform: scale(1);
    transform-origin: 0% 0%;
    opacity: 1;
    visibility: visible;
  }
  100% {
    transform: scale(0);
    transform-origin: 0% 0%;
    opacity: 0;
    visibility: hidden;
  }
`;

const animationDuration = "0.2s";

export const AttachmentListWrapper = styled.div<IAttachmentListWrapperStyleProps>`
    background: #fff;
    border-radius: 5px;
    padding: 10px;
    max-width: 400px;
    box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.2);

    transform: ${(props) => props.Visible ? "scale(1)" : "scale(0)"};
    visibility: ${(props) => props.Visible ? "visible" : "hidden"};
    animation: ${(props) => !props.ShouldAnimate ? "none" : props.Visible ? fadeIn : fadeOut} ${animationDuration};
    transition: visibility ${animationDuration};

    &:before {
        content: '';
        position: absolute;
        top: -10px;
        left: 15px;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
    }
`;

export const AttachmentListButton = styled.button`
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-weight: bold!important;
    color: #fff;
    background-color: ${Color.Blue.B60};
    align-items: center;
    border: none;
    border-radius: 5px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    height: 30px;
    justify-content: center;
    transition: all ease-in-out 0.15s;
    vertical-align: top;
    white-space: nowrap;

    padding: 0 8px;

    &:active {
        transform: translateY(1px);
    }

    &:hover {
        background-color: ${Color.Blue.B80};
    }

    &[disabled] {
        opacity: 0.4;
        pointer-events: none;
    }
`;
